<template lang="pug">
div.pr-5.pl-0.col-md-3(v-show="searchTokenHasCard")
  bin-card-vue(:bin_card="binCardData")
    template(v-slot:bin-buttons)
      slot(name="bin-buttons")
      i.fas.fa-external-link-square-alt(id='external_link', :title="t('components.bin_card.got_to_full_card')", @click="expandBINCard")

</template>
<script>
import bin_card_mixin from "common/mixins/bin_card_mixin"
import mixins from "common/mixins"
import { mapState, mapActions } from 'vuex'

export default {
  name: 'bin-card-wrapper-vue',
  props: {
    minimized: { type: Boolean, default: false }
  },
  mixins: [mixins.translate, bin_card_mixin.requests],
  data() {
    return {
      binCardData: {},
    }
  },
  components: {
    "bin-card-vue": () => import(/* webpackChunkName: "[request]" */ "components/bin_card/BINCard"),
  },
  methods: {
    expandBINCard(){
      this.goToBINCard(this.searchTokens[0], this.tokenId, this.searchTokens)
    },
    async fetchBINCardData(searchToken){
      this.binCardData = await this.fetchBinCard(searchToken)
    },
    resetBinCardDisplay(searchTokens){
      if(searchTokens != undefined){
        this.binCardData = {}
        if(searchTokens.length > 0){
          this.fetchBINCardData(searchTokens[0])
        }
      }
    },
    ...mapActions('search', ['fetchBinCard'])
  },
  computed: {
    searchTokenHasCard(){
      if (this.binCardData != undefined && "match" in this.binCardData) {
        return  Object.keys(this.binCardData).length > 0 && !this.minimized
      }
    },
    ...mapState('search', ['searchTokens', 'tokenId'])
  },
  watch: {
    searchTokens(newSearchToken){
      this.resetBinCardDisplay(newSearchToken)
    }
  },
  mounted(){
    this.resetBinCardDisplay(this.searchTokens)
  }
}
</script>
